import { CompositeLayer } from '@deck.gl/core';
import { PolygonLayer, ScatterplotLayer } from '@deck.gl/layers';

import { GeoFence, GeoFenceCircle, GeoFencePolygon } from '../../../types/Plan';

interface GeoFenceLayerProps {
  geoFences: GeoFence[];
}

class GeoFenceLayer extends CompositeLayer<GeoFenceLayerProps> {
  renderLayers() {
    const geoFencePolygonLayer = new PolygonLayer({
      id: 'geo-fence-polygon-layer',
      data: this.props.geoFences.filter((g) => g.type === 'polygon') as GeoFencePolygon[],
      getPolygon: (d: GeoFencePolygon) => d.polygon,
      getFillColor: () => [255, 0, 0, 63],
      getLineColor: () => [255, 0, 0, 255],
      getLineWidth: 2,
      pickable: true
    });

    const geoFenceCircleLayer = new ScatterplotLayer({
      id: 'geo-fence-circle-layer',
      data: this.props.geoFences.filter((g) => g.type === 'circle') as GeoFenceCircle[],
      getPosition: (d: GeoFenceCircle) => d.center,
      getRadius: (d: GeoFenceCircle) => d.radius,
      getFillColor: () => [255, 0, 0, 63],
      getLineColor: () => [255, 0, 0, 255],
      getLineWidth: 2,
      pickable: true
    });

    return [geoFencePolygonLayer, geoFenceCircleLayer];
  }
}

export default GeoFenceLayer;
